import React from "react";
import Footer from "../home/Footer";
import Header from "../../views/Header";

const TermsConditions = () => {
  return (
    <div>
      {/* <Header/> */}
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-black text-center mt-8 md:mt-12 mb-8 text-4xl font-bold font-Cinzel">
            Terms and Conditions
          </h1>
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="p-6 sm:p-8 space-y-6 text-gray-800 font-Outfit text-sm sm:text-md">
              <p>
                Welcome to www.shop.verdical.in. This site is owned and operated
                by Verdical. By visiting our site and getting to the data,
                assets, administrations, items, and devices we give, you
                comprehend and consent to acknowledge and stick to the
                accompanying agreements as expressed in this arrangement
                (henceforth alluded to as ‘Client Agreement’).
              </p>
              <p>
                We maintain whatever authority is needed to change this User
                Agreement occasionally without notice. You acknowledge and agree
                that it is your obligation to review this User Agreement
                occasionally to look into any changes. Your proceeding with
                utilization of this site after such changes will comprise
                affirmation and understanding of the altered agreements.
              </p>
              <h4>RESPONSIBLE USE AND CONDUCT</h4>
              <p>
                By visiting our site and getting to the data, assets,
                administrations, items, and instruments we accommodate you,
                either straightforwardly or in a roundabout way (henceforth
                alluded to as ‘Assets’), you consent to utilize these Resources
                just for the reasons planned as allowed by (a) the particulars
                of this User Agreement, and (b) material regulations, guidelines
                and by and large acknowledged internet based practices or rules.
              </p>
              <p>Wherein, you understand that:</p>
              <ol>
                <li>
                  1. To get to our Resources, you might be expected to give
                  specific data about yourself, (for example, identification and
                  contact details) as a feature of the enlistment interaction,
                  or as a component of your capacity to utilize the Resources.
                  You agree that any data you give will continuously be exact,
                  right, and updated.
                </li>
                <br />
                <li>
                  2. You are answerable for keeping up with the privacy of any
                  login data related with any record you use to get to our
                  Resources. Likewise, you are answerable for movements of every
                  kind that happen under your record/s.
                </li>
                <br />
                <li>
                  3. Getting to (or endeavouring to get to) any of our Resources
                  using any and all means other than through the means we give,
                  is completely restricted. You explicitly make a deal to avoid
                  getting to (or endeavour to get to) any of our Resources
                  through any computerized, deceptive or capricious means.
                </li>
                <br />
                <li>
                  4. Participating in any movement that disturbs or impedes our
                  Resources, including the servers and additional organizations
                  to which our Resources are found or associated, is completely
                  restricted.
                </li>
                <br />
                <li>
                  5. Seeking to duplicate, copy, imitate, sell, exchange, or
                  trade our Resources is completely forbidden.
                </li>
                <br />
                <li>
                  6. You are exclusively answerable for any results,
                  misfortunes, or harms that we may straightforwardly or by
                  implication bring about or experience because of any
                  unapproved exercises directed by you, as made sense of above,
                  and may cause criminal or common responsibility.
                </li>
                <br />
                <li>
                  7. We might give different open specialized instruments on our
                  site, for example, blog remarks, blog entries, public visit,
                  discussions, message sheets, newsgroups, item evaluations and
                  audits, different virtual entertainment administrations, and
                  so on. You comprehend that by and large we don’t pre-screen or
                  screen the substance posted by clients of these different{" "}
                </li>
              </ol>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;
